import React, { useEffect, useState } from "react";
import { getGames, RegisterUser, Token_Generator, updateGameStatus } from "../../../actions/auth"
import AdminHeader from "../../layout/AdminHeader";
import GameCard from "./GameCard";
import swal from "sweetalert";

const Gamification = () => {
    const [registerUser, setRegisterUser] = useState([]);
    const [games, setGames] = useState([]);
    const [loader, setLoader] = useState(false);
    const [filterOption, setFilterOption] = useState("all");
    const [selectedGames, setSelectedGames] = useState([]);
    const [searchTerm, setSearchTerm] = useState("");
    const [flag, setFlag] = useState(false)

    useEffect(() => {
        const generateToken = async () => {
            const token = await Token_Generator()
            if (token) {
                localStorage.setItem("gameToken", JSON.stringify(token))
            }
        }

        generateToken()
        return () => {
            localStorage.removeItem("gameToken")
        }
    }, [])

    const fetch = async () => {
        setLoader(true);
        const response = await RegisterUser();
        const token = await Token_Generator()
        const gameRes = await getGames(token?.access_token)
        if (gameRes.message === "Data Retrieved Successfully") {
            const tempGame = Array.isArray(gameRes?.data) && gameRes?.data?.filter((ele) => ele.status === "Y")
            setGames(tempGame)
        }
        const tempData = Array.isArray(response) && (response || [])?.filter((ele) => ele.isLive === "Y");
        setRegisterUser(tempData);
        setLoader(false);
    };

    useEffect(() => {
        fetch();

    }, []);

    const fetchUserGame = async (code) => {
        setLoader(true)
        const token = JSON.parse(localStorage.getItem("gameToken"))
        const selectedGameRes = await getGames(token?.access_token, code)
        let tempSelectedGameRes = []
        Array.isArray(games) && games?.map((game) => {
            Array.isArray(selectedGameRes?.data) && selectedGameRes?.data?.map((ele) => {
                if (game.gameId === ele.gameId) {
                    tempSelectedGameRes.push({
                        gameId: ele.gameId,
                        customerPortal: ele?.customerPortal
                    })
                }
            })
        })
        setFlag(tempSelectedGameRes?.length ? true : false)
        setSelectedGames(tempSelectedGameRes)
    }

    const handleFilterChange = async (e) => {
        const selectedMerchantCode = e.target.value;
        setFilterOption(selectedMerchantCode);
        setSearchTerm("")

        if (selectedMerchantCode !== "all") {
            await fetchUserGame(selectedMerchantCode);
        }

        setLoader(false);
    };

    const handleSelect = (gameId, action) => {
        if (action === "Select") {
            setSelectedGames((prev) => [...prev, { gameId, customerPortal: false }]);
        } else {
            setSelectedGames((prev) => prev.filter((g) => g.gameId !== gameId));
        }
    };

    const filteredGames = games?.filter((game) =>
        game?.gameName?.toLowerCase().includes(searchTerm.toLowerCase())
    );
    const handleStatusUpdate = async () => {
        setLoader(true)
        const body = {
            merchantCode: filterOption,
            type: "merchant",
            games: selectedGames
        }
        const token = JSON.parse(localStorage.getItem("gameToken"))
        const res = await updateGameStatus(token?.access_token, body)
        if (res.message === "Success") {
            await fetchUserGame(filterOption)
            swal({
                position: "center",
                icon: "success",
                title: "Games update successfully",
                showConfirmButton: false,
                timer: 5000,
            });
        } else {
            swal({
                position: "center",
                icon: "error",
                title: res.message,
                showConfirmButton: false,
                timer: 5000,
            });
        }

        setLoader(false)
    }
    return (
        <>
            <AdminHeader name={"Game List"} />
            {loader && (
                <div className="mainPreloaderMain">
                    <div className="mainPreloader">
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                    </div>
                </div>
            )}
            <div className="dashboard__content">
                <div className="container-fluid">
                    <div className="dashboard__customersCard">
                        <div className="dashboard__header">
                            <div className="dashboard__left">
                                <h4>Game List</h4>
                            </div>
                            <div className="dashboard__right">
                                <select value={filterOption} onChange={handleFilterChange}>
                                    <option value="all">Select</option>
                                    {(registerUser || [])?.map((opt, idx) => (
                                        <option key={idx} value={opt.merchcode}>
                                            {opt.name}
                                        </option>
                                    ))}
                                </select>
                            </div>
                        </div>
                        <div className="giftcard_mainbox">
                            <div className="gc_contentbox  no_margin_left full_width">
                                <div className="gc_right_side">
                                    <span className="search_label">Search: </span>
                                    <input
                                        className="input"
                                        type="text"
                                        value={searchTerm}
                                        onChange={(e) => setSearchTerm(e.target.value)}
                                    />
                                </div>
                                <div className="gc_content_pbox">
                                    {filteredGames?.length ? (
                                        <>
                                            <div className="campaignSelection__boxes">
                                                <div className="gc_inmainbox">
                                                    {filteredGames?.map((item, i) => (
                                                        <div key={i} className="game_innbox">
                                                            <GameCard
                                                                item={item}
                                                                handleSelect={handleSelect}
                                                                isSelected={selectedGames}
                                                                filterOption={filterOption}
                                                            />
                                                        </div>
                                                    ))}
                                                </div>
                                            </div>
                                            {filterOption === "all" ? <></> : <div
                                                className="row"
                                                style={{ paddingBottom: "20px" }}
                                            >
                                                <div className="col-sm-12 col-md-12 col-lg-12 col-xl-12">
                                                    <div
                                                        className="button-section"
                                                        style={{
                                                            display: "flex",
                                                            justifyContent: "flex-end",
                                                        }}
                                                    >
                                                        <button
                                                            type="submit"
                                                            onClick={handleStatusUpdate}
                                                            className="btn btn-primary btn-lg"
                                                            disabled={selectedGames?.length > 0 ? false : flag ? false : true}
                                                        >
                                                            Update
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>}
                                        </>
                                    ) : (
                                        <span className="not_found">No game found</span>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default Gamification